import { CacheableDataObject } from './CacheableDataObject';


export default class MatchTeam extends CacheableDataObject {

	hasWon() {
		return this.match.final_result === this.number;
	}

	hasLost() {
		return this.match.hasWinner() && this.match.final_result !== this.number;
	}
}